module.exports = __webpack_public_path__ + "static/media/instagram_icon.5694e81f.svg";